import React, { useEffect, useState } from 'react'
import './leave.css'
import LeaveDetails from '../../../componant/leave-details/leave-details';
import LeaveApplication from '../../../componant/leave-application/leave-application';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { getEmployeeLeaveDetails, getAllLeaveOfEmployee } from '../../../api-services/employee-services';
import { modalStyle } from '../../../style/style';
import ButtonWrapper from '../../../widgets/button/button';
import ModalWrapper from '../../../widgets/modal/modal';
import { TokenService } from '../../../services/token.service';

interface userLeaveDetails {
    leaveType: string,
    leaveBreaks: {
        earned: number,
        balance: number,
        carriedOver: number,
        entitled: number,
        taken: number,
        emergecy: number
    }
}
const UserLeave = () => {
    const [userLeveDetails, setUserLeaveDetails] = useState<userLeaveDetails[]>([])
    const [leaveType, setleaveType] = useState()
    const [openModal, setOpenModal] = useState<boolean>(false);
    const handleOpenModal = (item: any) => {
        setOpenModal(true);
        setleaveType(item)
    }
    const handleCloseModal = () => setOpenModal(false);
    const [openLeaveApplicationModal, setOpenLeaveApplicationModal] = useState<boolean>(false);
    const handleCloseLeaveApplicationModal = () => setOpenLeaveApplicationModal(false);
    const extractToken = TokenService.extractToken()

    useEffect(() => {
        Promise.all([
            getEmployeeLeaveDetails(extractToken?.sub),
            getAllLeaveOfEmployee(extractToken?.sub)
        ]).then(([detailsRes, historyRes]: any) => {
            if (detailsRes?.data?.success) {
                let details = detailsRes.data.payload;
                if (historyRes?.data?.success) {
                    const history = historyRes.data.payload;
                    details = details.map((item: any) => {
                        const myLeaves = history.filter((l: any) =>
                            l.leaveType?.toLowerCase().trim() === item.leaveType?.toLowerCase().trim() ||
                            l.leaveType?.toLowerCase().includes(item.leaveType?.toLowerCase().trim())
                        );

                        const takenDays = myLeaves.reduce((sum: number, l: any) => {
                            if (l.leaveStatus?.toLowerCase() === 'approved') {
                                return sum + Number(l.noOfDays || 0);
                            }
                            return sum;
                        }, 0);

                        const appliedDays = myLeaves.reduce((sum: number, l: any) => {
                            if (l.leaveStatus?.toLowerCase() === 'pending') {
                                return sum + Number(l.noOfDays || 0);
                            }
                            return sum;
                        }, 0);

                        const rejectedDays = myLeaves.reduce((sum: number, l: any) => {
                            if (l.leaveStatus?.toLowerCase() === 'rejected') {
                                return sum + Number(l.noOfDays || 0);
                            }
                            return sum;
                        }, 0);

                        let maxLeave = 0;
                        if (item.leaveType?.toLowerCase().includes('casual')) maxLeave = item.leaveBreaks.earned;
                        else if (item.leaveType?.toLowerCase().includes('medical') || item.leaveType?.toLowerCase().includes('sick')) maxLeave = item.leaveBreaks.earned;
                        else if (item.leaveType?.toLowerCase().includes('special')) maxLeave = item.leaveBreaks.earned;

                        if (maxLeave > 0) {
                            item.leaveBreaks.earned = maxLeave;
                            item.leaveBreaks.entitled = 0;
                            item.leaveBreaks.carriedOver = 0;
                        }

                        const totalAllowed = Number(item.leaveBreaks.earned || 0) + Number(item.leaveBreaks.entitled || 0) + Number(item.leaveBreaks.carriedOver || 0);
                        let newBalance = totalAllowed - (takenDays + appliedDays);
                        if (newBalance < 0) newBalance = 0;

                        return {
                            ...item,
                            leaveBreaks: {
                                ...item.leaveBreaks,
                                taken: takenDays,
                                applied: appliedDays,
                                reject: rejectedDays,
                                balance: newBalance
                            }
                        };
                    });
                }
                setUserLeaveDetails(details);
            }
        }).catch((err) => console.error(err));
    }, [extractToken?.sub])



    const handleLeaveApplication = () => {
        setOpenLeaveApplicationModal(true);
    }


    return (
        <>
            <div className='main' >
                <div className='main-container'>
                    <div className="heading heading-center-space-between height-40">
                        <h2>Leave Details</h2>
                        {/* <ButtonWrapper buttonType='circle' className='circular-add-button' onClick={handleLeaveApplication} tooltipTitle='Apply Leave' tooltipPlacement='left' /> */}
                    </div>
                    <div className='cal-40'>
                        <div className='leave-main-container'>
                            <div className='leave-details-heading-container'>
                                <div className='leave-type-head-container'>Type</div>
                                <div className='leave-details-head-container'>Details</div>
                            </div>
                            <div className='user-leave-details-main-container'>
                                <div className='user-leave-details-sub-container'>
                                    {
                                        userLeveDetails.map((item: any, index: number) => {
                                            return (
                                                <div className='leave-sub-container' key={index}>

                                                    <div className='leave-table-sub-container' >
                                                        <div className='leave-table-type-container'>
                                                            <div className='leave-type-container'>
                                                                <div>{item.leaveType}</div>
                                                            </div>
                                                        </div>
                                                        <div className='leave-table-details-container'>
                                                            <div className='leave-table-details-sub-container'>
                                                                <div className='leave-break-sub-container'>
                                                                    <div>
                                                                        <label>Balance</label>
                                                                        <div className='balance-container'>
                                                                            <div className={item.leaveBreaks.balance !== 0 ? 'leave-balance-show-container' : 'leave-balance-show-container1'}>{`${item.leaveBreaks.balance} Days`}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <label>Carried Over</label>
                                                                        <div>{item.leaveBreaks.carriedOver}</div>
                                                                    </div>
                                                                    <div>
                                                                        <label>Taken</label>
                                                                        <div>{item.leaveBreaks.taken}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='leave-break-sub-container'>
                                                                    <div>
                                                                        <label>Earned</label>
                                                                        <div>{item.leaveBreaks.earned}</div>
                                                                    </div>
                                                                    <div>
                                                                        <label>Entitled</label>
                                                                        <div>{item.leaveBreaks.entitled}</div>
                                                                    </div>
                                                                    <div>
                                                                        <label>Emergency</label>
                                                                        <div>{item.leaveBreaks.emergency}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='leave-break-sub-container'>
                                                                    <div>
                                                                        <label>Applied</label>
                                                                        <div>{item.leaveBreaks.applied || 0}</div>
                                                                    </div>
                                                                    <div>
                                                                        <label>Reject</label>
                                                                        <div>{item.leaveBreaks.reject || 0}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <ModalWrapper open={openLeaveApplicationModal} close={handleCloseLeaveApplicationModal} children={<LeaveApplication onClose={handleCloseLeaveApplicationModal} />} />
                                <ModalWrapper open={openModal} close={handleCloseModal} children={<LeaveDetails items={leaveType} onClose={handleCloseModal} />} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserLeave